import { render, staticRenderFns } from "./TeacherClassCalendarComponent.vue?vue&type=template&id=567096c3&"
import script from "./TeacherClassCalendarComponent.vue?vue&type=script&lang=js&"
export * from "./TeacherClassCalendarComponent.vue?vue&type=script&lang=js&"
import style0 from "./TeacherClassCalendarComponent.vue?vue&type=style&index=0&id=567096c3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports